import React, {useEffect} from 'react';
import {Route, Redirect, useHistory} from 'react-router-dom';
import {checkCookie, getCookie} from 'ubs-framework/v2/common/function';
import {useDispatch, useSelector} from "react-redux";
import {sendData} from "../store/actions";
const PrivateRoute = ({component: Component, ...rest}) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const _IA = useSelector(e => e.common.isAuthenticated)
    const rawOrgId = window.location.pathname.split('/')[1]
    const orgId = rest.path?.includes(':orgId') ? rawOrgId : null
    useEffect(() => {
        if (!checkCookie('ubs_token') && !checkCookie('signup_token')) history.push('/login')
        else if (!_IA) sendData(dispatch, 'authenticate', {token: getCookie("ubs_token") || getCookie("signup_token"), ...(orgId && {orgId})})
    }, [])

    return (
        <React.Fragment>
            {_IA && <Route {...rest} render={props => (
                (checkCookie('signup_token') || checkCookie('ubs_token')) ?
                       <Component {...props} />
                : <Redirect to="/login"/>
            )}/>}
        </React.Fragment>
    );
};

export default PrivateRoute;
